module.exports = __webpack_public_path__ + "img/glitter_6.697c2d29.jpg";